import api from '../api/client';
// utils/currency.js
export function formatKES(amount) {
  if (amount == null || isNaN(amount)) return "KES 0.00";

  return new Intl.NumberFormat("en-KE", {
    style: "currency",
    currency: "KES",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })?.format(amount)
    // .replace("KSh", "KES");
}

export const parseKES = (formattedAmount) => {
  if (typeof formattedAmount !== "string") return 0;
    
    const numericString = formattedAmount.replace(/[^0-9.-]+/g, "");
    const amount = parseFloat(numericString);
    return isNaN(amount) ? 0 : amount;
}